'use strict';

var templates = require('../templates');
var fobclient = require('..');
var AppUser = require('../entity').AppUser;

module.exports = function (connection) {
  return {
    byDnEquals: function byDnEquals(dn, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'byDnEquals', 'dn')(dn, additionalParams);
    },
    byDnLike: function byDnLike(dn, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'byDnLike', 'dn')(dn, additionalParams);
    },
    byEmailEquals: function byEmailEquals(email, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'byEmailEquals', 'email')(email, additionalParams);
    },
    byEmailLike: function byEmailLike(email, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'byEmailLike', 'email')(email, additionalParams);
    },
    byEnabledEquals: function byEnabledEquals(enabled, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'byEnabledEquals', 'enabled')(enabled, additionalParams);
    },
    byRoleEquals: function byRoleEquals(rolename, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'byRoleEquals', 'rolename')(rolename, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byUserNameEquals: function byUserNameEquals(username, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'byUserNameEquals', 'username')(username, additionalParams);
    },
    byUserNameLike: function byUserNameLike(username, additionalParams) {
      return templates.searchTemplate(connection)(AppUser, 'byUserNameLike', 'username')(username, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(AppUser, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('appuser')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/appUser.js
// module id = sbcY
// module chunks = 0